import React, { useCallback, useEffect, useRef, useState } from "react";
import axios from "../../store/axios";
import API_AUTH from "../../endpoints/auth";
import history from "../../routes/history";
import { storage, STORAGE_KEYS } from "../../utils/storage";
import i18n from "../../store/localization/i18n";

const productCodeToPath = {
    lotto5: "/lottery5",
    lotto6: "/lottery6",
    lotto12: "/lottery12",
    lotto90: "/lottery90",
    yuki: "/lottery1/12",
    lotto5D: "/lottery5D",
    lotto99: "/lottery1/99",
    roulette: "/roulette",
};

const VerifyAccessKey = ({ location }) => {
    const [status, setStatus] = useState("loading");
    const redirectTimer = useRef();

    const isMobileDevice = useCallback(() => {
        const ua = window.navigator.userAgent || "";
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    }, []);

    const performRedirect = useCallback((target, shouldReload = true) => {
        if (!target) return;
        const normalizedTarget = target.startsWith("/") ? target : `/${target}`;
        const destination = isMobileDevice() && !normalizedTarget.startsWith("/app")
            ? `/app${normalizedTarget}`
            : normalizedTarget;
        history.push(destination);
        if (shouldReload) {
            window.location.reload();
        }
    }, [isMobileDevice]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const accessKey = params.get("accessKey");
        const minimumDelay = 900;
        const startTime = Date.now();

        const finishAfterDelay = (fn) => {
            const elapsed = Date.now() - startTime;
            const wait = Math.max(minimumDelay - elapsed, 0);
            return window.setTimeout(fn, wait);
        };

        if (!accessKey) {
            finishAfterDelay(() => {
                setStatus("error");
            });
            return () => { };
        }

        axios.post(API_AUTH.VERIFY_ACCESS_KEY, { accessKey })
            .then((response) => {
                const data = response?.data?.data || {};
                const token = data.token;
                const redirectPath = data.redirectPath;
                const locale = data.locale;

                if (!token || !redirectPath) {
                    throw new Error("Invalid response");
                }

                if (locale) {
                    i18n.changeLanguage(locale);
                    window.localStorage.setItem("i18nextLng", locale);
                }

                storage.set(STORAGE_KEYS.accessToken, token);
                const target = productCodeToPath[redirectPath] || "/";

                finishAfterDelay(() => {
                    setStatus("success");
                    redirectTimer.current = window.setTimeout(() => performRedirect(target), 900);
                });
            })
            .catch(() => {
                finishAfterDelay(() => {
                    setStatus("error");
                });
            });

        return () => {
            if (redirectTimer.current) {
                window.clearTimeout(redirectTimer.current);
            }
        };
    }, [location.search, performRedirect]);

    const isError = status === "error";
    const isSuccess = status === "success";
    const isLoading = status === "loading";

    return (
        <div className="verify-splash d-flex align-items-center w-100 justify-content-center min-w-session">
            <div className="verify-splash-card text-center p-4 p-sm-5 w-75 w-lg-50" style={{ background: "rgba(0,0,0,0.75)", borderRadius: 16 }}>
                {!isError && <div className="form-login-title text-white mb-3" style={{ fontSize: 24, letterSpacing: 0.5 }}>Please wait...</div>}

                <div className={`d-flex justify-content-center ${isError ? "" : "mb-4"}`}>
                    {(isLoading || isSuccess) && (
                        <div className="spinner-border text-light" role="status" aria-label="Loading" />
                    )}
                    {isError && (
                        <div className="spinner-grow text-danger" role="status" aria-label="Error" />
                    )}
                </div>


                {!isError && (
                    <div className="progress mb-2" style={{ background: "rgba(255,255,255,0.2)" }}>
                        <div
                            className="progress-bar progress-bar-striped progress-bar-animated bg-info"
                            role="progressbar"
                            style={{ width: isSuccess ? "100%" : "65%" }}
                            aria-valuemin="0"
                            aria-valuemax="100"
                        />
                    </div>
                )}
                {
                    isError && <div>

                        <div className="text-warning font-weight-bold">
                            <p className="text-warning f-session">
                                វគ្គរបស់អ្នកបានផុតកំណត់ហើយ។ សូមចូលលេងហ្គេមម្តងទៀត។ សូមអរគុណ។ <br />
                                Your session has expired. Please log in to the game again. Thanks.
                            </p>
                        </div>
                    </div>
                }

            </div>
        </div >
    );
};

export default VerifyAccessKey;
